var _rect, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundFormsDarkSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    opacity: 0.1,
    width: "100%",
    height: "100%",
    viewBox: "0 0 1920 2453",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-20 700) scale(0.7)",
    d: "M475.054 1070.8C440.537 1098.32 424.734 1135.05 419.012 1180.59C413.29 1226.12 396.598 1260.85 362.64 1287.94C328.209 1315.4 294.179 1322.92 246.383 1316.47C198.587 1310.02 165.432 1317.73 131.445 1344.84C68.1186 1395.33 56.3022 1489.46 105.031 1555.08C153.759 1620.71 244.591 1632.95 307.917 1582.45C342.105 1555.19 357.922 1521.13 363.873 1473.85C369.81 1426.58 385.9 1392.6 420.116 1365.31C454.762 1337.69 488.907 1330.38 537.104 1336.89C585.302 1343.4 617.711 1335.42 651.555 1308.43C714.881 1257.93 726.698 1163.81 677.969 1098.18C629.241 1032.56 538.409 1020.32 475.082 1070.81L475.054 1070.8Z",
    fill: "#755DDF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 1441.5,
    r: 100,
    fill: "#755DDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.7) translate(900 0)",
    d: "M1920 260C1831.1 260 1743.06 277.511 1660.92 311.534C1578.79 345.556 1504.15 395.423 1441.29 458.289C1378.42 521.154 1328.56 595.786 1294.53 677.923C1260.51 760.061 1243 848.095 1243 937C1243 1025.9 1260.51 1113.94 1294.53 1196.08C1328.56 1278.21 1378.42 1352.85 1441.29 1415.71C1504.15 1478.58 1578.79 1528.44 1660.92 1562.47C1743.06 1596.49 1831.1 1614 1920 1614L1920 937V260Z",
    fill: "#755DDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundFormsDarkSecondary);
export default __webpack_public_path__ + "static/media/background_forms_dark_secondary.f108842084a684748501105e1f9ef26e.svg";
export { ForwardRef as ReactComponent };